import { render, staticRenderFns } from "./removerecipient.vue?vue&type=template&id=3cf76784&"
import script from "./removerecipient.vue?vue&type=script&lang=js&"
export * from "./removerecipient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports